import { UniQState } from "../Interfaces/IInitialState";

export const initialState: UniQState = {
  newMessage: {
    data: null,
    isLoading: false,
  },
  messages: {
    data: [],
    isLoading: false,
  },
  defaultPrompt: {
    isVisible: false,
    isSaving: false,
    isFetching: false,
    data: {
      caseFullDetails: {},
      aiGeneratedSummary: [],
      additionalMessages: [],
      executedUserPrompt: "",
    },
  },
  sessionReset: {
    data: null,
    isLoading: false,
    isSuccess: false,
  },
};
